import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import HistoryQPage3, { ICustomProps } from './index';
import { InputFieldConfig } from '../../../../types';
import { PartnerVisaStatus } from 'api-paths-cas';

const mapStateToProps = (state: ApplicationState): ICustomProps => {
  const {
    FamilyMembersTravelling: familyMembersTravellingConfig,
    SpouseTravelling: spouseTravellingConfig,
    PartnerVisaStatus: partnerVisaStatusConfig,
    ChildrenTravelling: childrenTravellingConfig,
    ChildrenTravellingNumber: childrenTravellingNumberConfig,
  }: {
    FamilyMembersTravelling: InputFieldConfig;
    SpouseTravelling: InputFieldConfig;
    PartnerVisaStatus: InputFieldConfig;
    ChildrenTravelling: InputFieldConfig;
    ChildrenTravellingNumber: InputFieldConfig;
  } = state.student.config.Checklist.History.Page3;

  const {
    hasDependents,
    hasPartner,
    partnerVisaStatus = '' as PartnerVisaStatus,
    hasChildren,
    childrenNum = 0,
  } = state.student.offer;

  const familyMembersTravellingVisible = familyMembersTravellingConfig?.visible ?? true;
  const spouseTravellingVisible = spouseTravellingConfig?.visible ?? true;
  const partnerVisaStatusVisible = (partnerVisaStatusConfig?.visible ?? true) && hasPartner === true;
  const childrenTravellingVisible = childrenTravellingConfig?.visible ?? true;
  const childrenTravellingNumberVisible = (childrenTravellingNumberConfig?.visible ?? true) && hasChildren === true;

  const familyMembersTravellingMandatory = familyMembersTravellingConfig?.mandatory ?? true;
  const spouseTravellingMandatory = spouseTravellingConfig?.mandatory ?? true;
  const partnerVisaStatusMandatory = partnerVisaStatusConfig?.mandatory ?? true;
  const childrenTravellingMandatory = childrenTravellingConfig?.mandatory ?? true;
  const childrenTravellingNumberMandatory = childrenTravellingNumberConfig?.mandatory ?? true;

  // prettier-ignore
  const complete =

    (!familyMembersTravellingVisible || !familyMembersTravellingMandatory || hasDependents !== undefined) &&
    (!spouseTravellingVisible || !spouseTravellingMandatory || hasPartner !== undefined) &&
    (!partnerVisaStatusVisible || !partnerVisaStatusMandatory || partnerVisaStatus !== ('' as PartnerVisaStatus)) &&
    (!childrenTravellingVisible || !childrenTravellingMandatory || hasChildren !== undefined) &&
    (!childrenTravellingNumberVisible || !childrenTravellingNumberMandatory || Number(childrenNum) > 0);

  return {
    sectionTitle: state.student.config.Checklist.History.shortTitle,
    complete,
    currentStep: 3,
    steps: 3,
    hasDependents,
    familyMembersTravellingVisible,
    familyMembersTravellingConfig,
    hasPartner,
    spouseTravellingVisible,
    spouseTravellingConfig,
    partnerVisaStatus,
    partnerVisaStatusVisible,
    partnerVisaStatusConfig,
    hasChildren,
    childrenTravellingVisible,
    childrenTravellingConfig,
    childrenNum: Number(childrenNum),
    childrenTravellingNumberVisible,
    childrenTravellingNumberConfig,
    config: state.student.config,
  };
};

export default connect(mapStateToProps)(HistoryQPage3);
